import { NgDialogsModule, NgInputsModule, NgPipesModule, NgStylingComponentsModule, NgYoutubeVideoPreviewComponent } from '@libs/frameworks/angular';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { SparkLayoutModule } from '@domains/frontend/templates/spark';
import { UiHeaderComponentsModule } from '@domains/frontend/ui-components';

import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { ScaleLayoutComponent } from './header/scale-layout/scale-layout.component';
import { EventThemeModule } from '../template-views/event-theme/event-theme.module';
import { AgentPanelComponent } from './agent-panel/agent-panel.component';
import { AgentRequest } from '../../requests/shared/agent/agent.request';
import { UpdateBannerComponent } from './update-banner/update-banner.component';
import { UpdateBadgeComponent } from './update-badge/update-badge.component';
import { UpdateContentComponent } from './update-content/update-content.component';


@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		SidebarComponent,
		ScaleLayoutComponent,
		AgentPanelComponent,
		UpdateBannerComponent,
		UpdateBadgeComponent,
		UpdateContentComponent
	],
	imports		: [
		CommonModule,
		SparkLayoutModule,
		NgbDropdownModule,
		UiHeaderComponentsModule,
		NgStylingComponentsModule,
		EventThemeModule,
		NgDialogsModule,
		FormsModule,
		RouterModule,
		NgInputsModule,
		NgPipesModule,
		NgYoutubeVideoPreviewComponent
	],
	exports		: [
		HeaderComponent,
		FooterComponent,
		SidebarComponent,
		AgentPanelComponent,
		UpdateBannerComponent,
		UpdateBadgeComponent
	],
	providers	: [AgentRequest]
})
export class LayoutModule {}
